/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {ControlledSubstancePermitService} from './controlled-substance-permit.service';

@NgModule({
    providers: [
        ControlledSubstancePermitService
    ]
})
export class ControlledSubstancePermitModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/professional/permit/controlled-substance-permit.module.ts